export default "__VITE_ASSET__vA4rvjg7__"